import Check from './components/icons/Check';
import CheckDocument from './components/icons/CheckDocument';
import Document from './components/icons/Document';
import Peso from './components/icons/Peso';

export const iconsAndLabels = [
  {
    icon: Check,
    label: 'Info.contract.recover',
  },
  {
    icon: CheckDocument,
    label: 'Info.contract.checkdocument',
  },
  {
    icon: Document,
    label: 'Info.contract.document',
  },
  {
    icon: Peso,
    label: 'Info.contract.peso',
  },
];

export const getIsPayLater = (result: number): boolean => {
  return result * 0.25 >= 349;
};
